<template>
  <InnerCardInfo
    v-if="clothesSizes"
    :label="localStorage.translations.pages['setting-personal_area'].sections['spetsodezhda']"
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['obuv'],
        value: (clothesSizes && clothesSizes.size_shoes) || '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['kurtka'],
        value: (clothesSizes && clothesSizes.size_jacket) || '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['shtany'],
        value: (clothesSizes && clothesSizes.size_pants) || '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['perchatki'],
        value: (clothesSizes && clothesSizes.size_gloves) || '-',
      },
    ]"
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'ClothesSizesPdf',
  props: { clothesSizes: Object, editReady: Boolean },
  components: { InnerCardInfo },
}
</script>
